import PurchaseConfirmationModalOffer from './purchaseConfirmationModalOffer'

export default PurchaseConfirmationModalOffer
